// extracted by mini-css-extract-plugin
module.exports = {"tooltiptext":"ProductsTable_tooltiptext__3WEZj","skeleton":"ProductsTable_skeleton__5teJT"};